<!-- src/components/filters/DepositionalEnvironmentFilter.vue -->
<template>
  <ListFilter field="depositional_environment" :options="opts" label="Обстановка осадко-накопления" @filter="$emit('filter',$event)" @openDetail="$emit('openDetail',$event)"/>
</template>

<script>
import ListFilter from './ListFilter.vue'
export default {
  name: 'DepositionalEnvironmentFilter',
  components: { ListFilter },
  data() {
    return {
      opts: ['морская','прибрежно-морская']
    }
  }
}
</script>
